import { render, staticRenderFns } from "./CoveragesCard.vue?vue&type=template&id=311ef7e9"
import script from "./CoveragesCard.vue?vue&type=script&lang=js"
export * from "./CoveragesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports